var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBarCircled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 212836474"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 4",
    cx: 21,
    cy: 21,
    r: 20.5,
    fill: "white",
    stroke: "#CBD5E1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 19.4211H12.3684V27H9V19.4211ZM20.7895 16.0526H24.1579V27H20.7895V16.0526ZM14.8947 11H18.2632V27H14.8947V11Z",
    fill: "#63658E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M31 25L27 21H35L31 25Z",
    fill: "#63658E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarCircled);
export default __webpack_public_path__ + "static/media/barCircled.f7cb7453eb9546fde7468160b568be90.svg";
export { ForwardRef as ReactComponent };